import { render } from "./Feedback.vue?vue&type=template&id=08a8cd96&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=08a8cd96&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=08a8cd96&lang=scss"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a8cd96"]])

export default __exports__